import { fetchServices } from '@/api/service'
const getDownloadAllVoucher = (context) => {
  fetchServices().then((response) => {
    var hasService = { haveTaxi: 0, haveTrain: 0, haveRentalCar: 0, haveRefreshment: 0, haveHotel: 0, haveBus: 0 }
    _.find(response, function (o) {
      if (o.service_id == 4) {
        hasService.haveTaxi = 1
      }
      if (o.service_id == 2) {
        hasService.haveRefreshment = 1
      }
      if (o.service_id == 1) {
        hasService.haveHotel = 1
      }
      if (o.service_id == 3) {
        hasService.haveBus = 1
      }
      if (o.service_id == 5) {
        hasService.haveTrain = 1
      }
      if (o.service_id == 6) {
        hasService.haveRentalCar = 1
      }
    })
    context.commit('DOWNLOADALLVOUCHER_UPDATED', hasService)
  })
}

export default {
  getDownloadAllVoucher
}
